type SeasonGateResult = {
  success: boolean;
  content?: {
    ordering_available: boolean;
  };
};

export const isOrderingUnavailable = (result: SeasonGateResult) =>
  result.success && result.content?.ordering_available === false;
